import React from "react";
import { App } from "context/AppContext";
import magicStick from "assets/images/magic_stick.png";

function ThemeSwitcher({ switchTheme }) {
  const { darkMode, setDarkMode } = App();

  return (
    <div
      style={{
        position: "fixed",
        bottom: 30,
        right: 30,
        zIndex: 100,
        backgroundColor: "#fff",
        borderRadius: "50px",
        height: "40px",
        width: "40px",
        boxShadow: "0px 4px 10px 5px #ccc",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
      }}
      onClick={() => {
        switchTheme();
        setDarkMode(!darkMode);
        localStorage.setItem("darkMode", !darkMode);
      }}
    >
      <img
        alt=""
        src={magicStick}
        height="20px"
        style={{
          "&:hover": {
            background: "red",
          },
        }}
      />
    </div>
  );
}

export default ThemeSwitcher;
